<ng-container *mobxAutorun>
  <ion-row class="ion-margin-bottom ion-align-items-start" *ngIf="isDesktop">
    <ion-card
      class="ion-no-margin md-border flex performance-card"
      *ngFor="let item of headerItems"
    >
      <ion-row class="ion-padding">
        <ion-text color="dark">
          <b>{{ item.label | translate }}</b>
        </ion-text>
      </ion-row>
      <leaderboard-card
        [loading]="item.loading"
        [leaderboard]="$any(item.value)"
        [fullView]="fullView"
        [valueToShow]="item.key"
        [empty]="!item.value && !item.loading"
      >
      </leaderboard-card>
    </ion-card>
  </ion-row>

  <leaderboard-list
    [paginatedLeaderboard]="paginatedLeaderboardEntries"
    [readonly]="true"
    [loading]="loading"
    [showFullButton]="false"
    [fullView]="fullView"
    *ngIf="!isDesktop"
  >
  </leaderboard-list>

  <ion-card class="ion-padding ion-no-margin md-border" *ngIf="isDesktop">
    <table cdk-table [dataSource]="loading ? loadingDataSource$ : datasource$">
      <ng-container [cdkColumnDef]="column.key" *ngFor="let column of displayColumns">
        <th
          ns-table-header-cell
          *cdkHeaderCellDef
          cdk-header-cell
          (onSort)="adjustSort($event)"
          [column]="column"
          [sortKey]="sortKey$.value"
          [sortDirection]="sortDirection$.value"
        ></th>
        <ng-container *ngIf="column.key === 'order'">
          <ns-table-cell
            cdk-cell
            *cdkCellDef="let row"
            (onToggle)="toggleRow($event)"
            [row]="row"
            [column]="column"
            [loading]="loading"
            [disabledCheckbox]="loading"
          >
          </ns-table-cell>
        </ng-container>

        <ng-container *ngIf="column.key === 'badges'">
          <td cdk-cell *cdkCellDef="let row">
            <ion-icon
              *ngFor="let badge of row.badges"
              class="badge-icon"
              [tooltip]="badge.description"
              [hide-delay]="25"
              [options]="{ placement: 'bottom' }"
              [src]="'https://cdn.stable.netsocialapp.com/netsocial/badges/' + badge.imageSvgSmall"
            >
            </ion-icon>
            <ion-skeleton-text *ngIf="loading" animated></ion-skeleton-text>
          </td>
        </ng-container>

        <ng-container *ngIf="column.key === 'profile'">
          <ion-col cdk-cell *cdkCellDef="let row" class="ion-no-padding">
            <ion-item class="ion-margin-vertical md-transparent">
              <ion-avatar slot="start">
                <ng-container *ngIf="loading">
                  <ion-skeleton-text animated></ion-skeleton-text>
                </ng-container>
                <ng-container *ngIf="!loading">
                  <entity-avatar [entity]="row.profile"> </entity-avatar>
                </ng-container>
              </ion-avatar>
              <ion-label>
                <h3 class="ly-row ion-align-items-center">
                  <ng-container *ngIf="loading">
                    <ion-skeleton-text animated></ion-skeleton-text>
                  </ng-container>
                  <ng-container *ngIf="!loading">
                    <ion-text
                      class="ly-row ion-align-items-center ion-margin-end"
                      [color]="
                        row.statistics.value.indication === 'positive' ? 'success' : 'danger'
                      "
                    >
                      <ion-icon
                        [name]="
                          row.statistics.value.indication === 'positive' ? 'arrow-up' : 'arrow-down'
                        "
                      >
                      </ion-icon>
                      <b>{{ row.statistics.value.change }}</b>
                    </ion-text>
                    <b>{{ row.profile.fullName }}</b>
                  </ng-container>
                </h3>
              </ion-label>
            </ion-item>
          </ion-col>
        </ng-container>

        <td cdk-cell *cdkCellDef="let row" class="ion-text-center no-padding">
          <ion-skeleton-text animated *ngIf="loading"></ion-skeleton-text>
          <ion-text *ngIf="!loading">
            <b>{{ row.statistics[column.key].current }}</b>
          </ion-text>
        </td>
      </ng-container>

      <tr cdk-header-row *cdkHeaderRowDef="_columns$.value"></tr>
      <cdk-row
        class="group-{{ row.id }} {{ fullView && row.order < 4 && !loading ? 'highlighted' : '' }}"
        *cdkRowDef="let row; columns: _columns$.value"
      >
      </cdk-row>
    </table>
    <div class="md-icon-message md-fill" *ngIf="!loading && !datasource$.value.length">
      <ion-icon size="large" name="people-circle"> </ion-icon>
      <ion-text class="ion-text-center">
        <h4>
          {{ 'components.leaderboard.messages.emptyMessage' | translate }}
        </h4>
        <h6>
          {{ 'components.leaderboard.messages.emptyDescription' | translate }}
        </h6>
      </ion-text>
    </div>
  </ion-card>

  <ion-row
    class="ion-justify-content-end ion-margin-vertical"
    *ngIf="isDesktop && !hidePaging && !loading && paginatedLeaderboardEntries?.canLoadMore"
  >
    <ion-button
      [disabled]="getLeaderboardEntriesPageSubscription"
      (click)="getLeaderboardEntries(paginatedLeaderboardEntries?.paging?.next)"
    >
      {{ 'viewMoreText' | translate }}
    </ion-button>
  </ion-row>
</ng-container>
